/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type ScheduleWeekMode = typeof ScheduleWeekMode[keyof typeof ScheduleWeekMode];


export const ScheduleWeekMode = {
  None: 'None',
  Repeat: 'Repeat',
  Skip: 'Skip',
} as const;
